/**
 * 注入nuxt全局的缓存模块
 * 主要用于服务端全局cached
 */

import LRU from 'lru-cache';

export const MAX_AGE = 5 * 60 * 1000; // 与组件缓存时间保持一致

export default {
  // 在nuxt全局注入cached
  init() {
    process.selfCached = new LRU({
      max: 1000,
      maxAge: MAX_AGE,
    });
  },

  set(key, data) {
    process.selfCached && process.selfCached.set(key, data);
  },

  get(key) {
    return process.selfCached && process.selfCached.get(key);
  },
};
